import React, {Component} from 'react';
import {Col, Row} from 'react-bootstrap';
//CSS
import '../LandingSubcomponents/Servicios.css';
import compraOnline from '../../../assets/img/servicios/compra-online.png';
import logistica from '../../../assets/img/servicios/expertos-logistica.png';
import pediRecibi from '../../../assets/img/servicios/pedi-recibi.png';
import promociones from '../../../assets/img/servicios/promociones.png';
//Components
import MonitoreoDigital from "../LandingSubcomponents/Servicios/MonitoreoDigital";
import Entregas from "../LandingSubcomponents/Servicios/Entregas";
import Promociones from "../LandingSubcomponents/Servicios/Promociones";
import Stock from "../LandingSubcomponents/Servicios/Stock";

//Images

class Servicios extends Component {
    render() {

        return (
            <div id="servicios">
                <Row className="servicio">
                    <h2 className="wow animated fadeIn" data-wow-duration="1s">
                        Nos destacamos por
                    </h2>
                    <Row>
                        <div style={{maxWidth: "1310px", margin: "0 auto"}}>
                            <Col md={3} sm={6} xs={12}
                                 className="wow animated bounceInUp service"
                                 data-wow-duration="1.5s" data-wow-delay="0s"
                            >
                                <img src={compraOnline} alt="compra-online"/>

                                <h4>
                                    Atención al cliente
                                </h4>

                                <p>
                                    Desde nuestros vendedores y repartidores hasta quienes preparan los pedidos y
                                    responden tus consultas. Todos comprometidos en brindarte un servicio de excelencia.
                                </p>
                            </Col>
                            <Col md={3} sm={6} xs={12}
                                 className="wow animated bounceInUp service"
                                 data-wow-duration="1.5s" data-wow-delay=".3s"
                            >
                                <img src={logistica} alt="envio-gratis"/>

                                <h4>
                                    Expertos en Logística
                                </h4>

                                <p>
                                    Contamos con más de 25 años de experiencia en logística para entregar de la manera
                                    más eficiente tu pedido.
                                </p>
                            </Col>
                            <Col md={3} sm={6} xs={12}
                                 className="wow animated bounceInUp service"
                                 data-wow-duration="1.5s" data-wow-delay=".9s"
                            >
                                <img src={promociones} alt="promociones"/>

                                <h4>
                                    Promociones
                                </h4>

                                <p>
                                    Realizamos promociones mensuales para que puedas obtener mayores beneficios en tus
                                    compras.
                                </p>
                            </Col>
                            <Col md={3} sm={6} xs={12}
                                 className="wow animated bounceInUp service"
                                 data-wow-duration="1.5s" data-wow-delay=".6s"
                            >
                                <img src={pediRecibi} alt="pedi-recibi"/>

                                <h4>
                                    Productos
                                </h4>

                                <p>
                                    Trabajamos todos los rubros, ofreciendo calidad y amplio stock de mercadería para surtir a nuestros clientes.
                                </p>
                            </Col>

                        </div>
                    </Row>
                </Row>
                <MonitoreoDigital/>
                <Entregas/>
                <Stock/>

            </div>
        );
    }
}


export default Servicios;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios.js